type Props = { extraClasses?: string };

const Section = ({ children, extraClasses }: React.PropsWithChildren<Props>) => {
    return <section className={extraClasses}>{children}</section>;
};

export default Section;
